import i18n from '@/utils/i18n';
import React from 'react';
import { CartSwitcherTabs } from './multi-cart/cart-switcher-tabs';
import { CollapsibleAlerts } from '@/components/collapsible-alerts';
import { createStyles } from '@/contexts/theme-context';
import { ListEmptyState } from '@/components/list-empty-state';
import { SearchInput } from '@/components/search-input';
import { ValidateOrderAlert } from '@/types';
import { View } from 'react-native';

interface Props {
  alerts: ValidateOrderAlert[];
  isSearching: boolean;
  multiCartEnabled: boolean;
  onNewCartPress: () => void;
  onSearchChange: (searchTerm: string) => void;
  onSeeAllCartsPress: () => void;
  searchTerm: string;
  showNoResults: boolean;
}

export const OrderSummaryListHeader: React.FC<Props> = React.memo(
  ({
    alerts,
    isSearching,
    multiCartEnabled,
    onNewCartPress,
    onSearchChange,
    onSeeAllCartsPress,
    searchTerm,
    showNoResults,
  }) => {
    const [styles] = useStyles();

    return (
      <>
        <View style={styles.listHeader}>
          {multiCartEnabled ? (
            <CartSwitcherTabs
              onNewCartPress={onNewCartPress}
              onSeeAllPress={onSeeAllCartsPress}
            />
          ) : null}
          <SearchInput
            autoCorrect={false}
            containerStyle={styles.searchContainer}
            isLoading={isSearching}
            onChangeText={onSearchChange}
            placeholder={i18n.t('find_in_this_cart')}
            value={searchTerm}
          />
        </View>
        <CollapsibleAlerts alerts={alerts} containerStyle={styles.alerts} />
        {showNoResults ? (
          <ListEmptyState text={i18n.t('no_results_for', { searchTerm })} />
        ) : null}
      </>
    );
  },
);

const useStyles = createStyles((theme) => ({
  alerts: {
    marginTop: 8,
  },
  listHeader: {
    backgroundColor: theme.colors.white,
  },
  searchContainer: {
    backgroundColor: theme.colors.background,
    height: 48,
    marginBottom: 8,
    marginHorizontal: 16,
  },
}));
